module.exports = __webpack_public_path__ + "img/xiaomi12tKV.b4678699.png";